import type { Flow, UpdateFlowApiArg } from 'lib-shared-types-api';
import { useCallback } from 'react';

import { flowsApi } from 'apis/flows';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

type CallbackPayload = {
  flow: Partial<Flow>;
  id: Flow['id'];
};

/** A hook that handles renaming a flow. */
export const useUpdateFlow = () => {
  const dispatch = useAppDispatch();

  const updateFlow = useCallback(
    async ({ flow, id: flowId }: CallbackPayload) => {
      const { data: currentFlow } = await dispatch(
        flowsApi.endpoints.readFlow.initiate({ id: flowId }),
      ).unwrap();

      const payload: UpdateFlowApiArg = {
        flow: { ...currentFlow, ...flow },
        id: flowId,
      };

      return dispatch(flowsApi.endpoints.updateFlow.initiate(payload));
    },
    [dispatch],
  );

  return updateFlow;
};
